export default __webpack_public_path__ + "static/media/011.602e06ae.jpg";